/* esm.sh - lib0@0.2.117/set */
var e=()=>new Set,r=t=>Array.from(t),o=t=>t.values().next().value,n=t=>new Set(t);export{e as create,o as first,n as from,r as toArray};
//# sourceMappingURL=set.mjs.map